import {useParams} from "react-router-dom";
import React from "react";
import {FTPBreadCrumbs} from "../../components-new/BreadCrumbs";

export const BMHomeCrumbs = (props) => {
    const {projectid} = useParams();

    const crumbs = [
        {name: "DashBoard", href: `/project/${projectid}`, current: true},
        {name: 'Beneficiary Management', href: `/project/${projectid}/beneficiary_v2`, current: true},
    ];
    return (
        <FTPBreadCrumbs crumbs={crumbs}/>
    )
}